import { Injectable } from '@angular/core';
import { StackLogService, LogEntry, LogQueryOptions } from './stack-log.service';

@Injectable({
  providedIn: 'root'
})
export class LoggingConsoleService {
  private registered = false;

  constructor(private readonly stackLogService: StackLogService) {}

  registerDevToolsHelpers(): void {
    if (this.registered || typeof window === 'undefined') {
      return;
    }
    const globalScope = globalThis as any;
    if (typeof globalScope.collectLogs !== 'function') {
      globalScope.collectLogs = this.collectLogs;
    }
    if (typeof globalScope.downloadLogs !== 'function') {
      globalScope.downloadLogs = this.downloadLogs;
    }
    this.registered = true;
    // eslint-disable-next-line no-console
    console.log('DevTools helper `downloadLogs()` / `collectLogs()` is ready.');
  }

  private collectLogs = async (options?: LogQueryOptions): Promise<LogEntry[]> => {
    const entries = await this.stackLogService.queryEntries(options);
    if (!entries.length) {
      // eslint-disable-next-line no-console
      console.info('collectLogs: No entries matched the provided criteria.');
      return [];
    }
    const lines = this.stackLogService.formatEntries(entries).split('\n');
    // eslint-disable-next-line no-console
    console.group(`[collectLogs] ${entries.length} entries`);
    lines.forEach(line => {
      // eslint-disable-next-line no-console
      console.log(line);
    });
    // eslint-disable-next-line no-console
    console.groupEnd();
    return entries;
  };

  private downloadLogs = async (options?: LogQueryOptions): Promise<void> => {
    const entries = await this.stackLogService.queryEntries(options);
    if (!entries.length) {
      // eslint-disable-next-line no-console
      console.warn('downloadLogs: No entries matched the provided criteria.');
      return;
    }
    const content = this.stackLogService.formatEntries(entries);
    const blob = new Blob([content], { type: 'text/plain;charset=utf-8' });
    const filename = `logs-${new Date().toISOString().replace(/[:.]/g, '-')}.log`;
    const url = window.URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = filename;
    anchor.style.display = 'none';
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
    window.URL.revokeObjectURL(url);
    // eslint-disable-next-line no-console
    console.log(`Log file downloaded: ${filename}`);
  };
}
